var SupportFinePrintPresenterPresentation, SupportUtilsHelper;

SupportUtilsHelper = require('../helpers/utils');

SupportFinePrintPresenterPresentation = (function() {
  function SupportFinePrintPresenterPresentation() {}

  SupportFinePrintPresenterPresentation.prototype.present = function(order) {
    var text;
    return text = (function() {
      switch (order.DEAL_TYPE) {
        case 'GETAWAYS_MARKET_RATE':
          return this.marketRateFinePrintConstructor(order);
        default:
          return this.v1FinePrintConstructor(order);
      }
    }).call(this);
  };

  SupportFinePrintPresenterPresentation.prototype.v1FinePrintConstructor = function(order) {
    var ref;
    if (order == null) {
      return "";
    }
    return replaceNewLineWithBreak((ref = order.deal) != null ? ref.finePrint : void 0);
  };

  SupportFinePrintPresenterPresentation.prototype.marketRateFinePrintConstructor = function(order) {
    var cancellationPolicies, reservationSource;
    reservationSource = SupportUtilsHelper.getReservationSource(order);
    if (reservationSource == null) {
      return "";
    }
    cancellationPolicies = _.reduce(reservationSource.cancellationPolicies, (function(memo, policy) {
      return "" + memo + policy.descriptionHtml + " <br />";
    }), "");
    return reservationSource.crsPolicyHtml + " <br />Cancellation Policies <br /><br /> " + cancellationPolicies;
  };

  return SupportFinePrintPresenterPresentation;

})();

module.exports = SupportFinePrintPresenterPresentation;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUva3VtYXJyYS9uYXBpc3RyYW5vL2J1aWxkLzE1MDQ3NzgxNDM1MjYtNzYxNzcvcHJvZHVjdGlvbi0yMDE3LjA5LjA3XzA5LjU0L3N1cHBvcnRfYXBwL21vZHVsZXMvc3VwcG9ydC9mcm9udGVuZC9wcmVzZW50ZXJzL2ZpbmVfcHJpbnRfcHJlc2VudGVyLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL2t1bWFycmEvbmFwaXN0cmFuby9idWlsZC8xNTA0Nzc4MTQzNTI2LTc2MTc3L3Byb2R1Y3Rpb24tMjAxNy4wOS4wN18wOS41NC9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvcHJlc2VudGVycy9maW5lX3ByaW50X3ByZXNlbnRlci5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsSUFBQTs7QUFBQSxrQkFBQSxHQUFxQixPQUFBLENBQVEsa0JBQVI7O0FBRWY7OztrREFDSixPQUFBLEdBQVMsU0FBQyxLQUFEO0FBQ1AsUUFBQTtXQUFBLElBQUE7QUFBTyxjQUFPLEtBQUssQ0FBQyxTQUFiO0FBQUEsYUFDQSxzQkFEQTtpQkFDNEIsSUFBQyxDQUFBLDhCQUFELENBQWdDLEtBQWhDO0FBRDVCO2lCQUVBLElBQUMsQ0FBQSxzQkFBRCxDQUF3QixLQUF4QjtBQUZBOztFQURBOztrREFLVCxzQkFBQSxHQUF3QixTQUFDLEtBQUQ7QUFDdEIsUUFBQTtJQUFBLElBQWlCLGFBQWpCO0FBQUEsYUFBTyxHQUFQOztXQUNBLHVCQUFBLGlDQUFrQyxDQUFFLGtCQUFwQztFQUZzQjs7a0RBSXhCLDhCQUFBLEdBQWdDLFNBQUMsS0FBRDtBQUM5QixRQUFBO0lBQUEsaUJBQUEsR0FBb0Isa0JBQWtCLENBQUMsb0JBQW5CLENBQXdDLEtBQXhDO0lBQ3BCLElBQWlCLHlCQUFqQjtBQUFBLGFBQU8sR0FBUDs7SUFDQSxvQkFBQSxHQUF1QixDQUFDLENBQUMsTUFBRixDQUFTLGlCQUFpQixDQUFDLG9CQUEzQixFQUFpRCxDQUFFLFNBQUMsSUFBRCxFQUFPLE1BQVA7YUFBa0IsRUFBQSxHQUFHLElBQUgsR0FBVSxNQUFNLENBQUMsZUFBakIsR0FBaUM7SUFBbkQsQ0FBRixDQUFqRCxFQUFrSCxFQUFsSDtXQUNwQixpQkFBaUIsQ0FBQyxhQUFuQixHQUFpQyw0Q0FBakMsR0FBNkU7RUFKakQ7Ozs7OztBQU1sQyxNQUFNLENBQUMsT0FBUCxHQUFpQiJ9
